import { isBrowser as r } from "./highrise1350.mjs";
const i = r && "chrome" in window;
r && navigator.userAgent.includes("Firefox");
const e = r && navigator.userAgent.includes("Safari") && !i;
export {
  i as isChrome,
  e as isSafari
};
